module.exports = require("@jswork/noop");